import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Card, Row, Col, Upload, message, UploadProps, DatePicker, FormInstance, InputNumber, Button, Modal } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { OperationTypeEnum, PlantsEnum, ShiftsEnum, SubPlantCodesEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { SoakingAssignmentService, ProdInvService, ProductionInventoryService, WorkstationService } from "@gtpl/shared-services/production";
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { LotCodeDropDown, LotInformationRequest, LotNoInfo, LotNumberRequest, WorkStationCategoryReq, WorkstationDTO, WorkStationsDropDown } from '@gtpl/shared-models/production-management';

import './assign-soaking-material.css';
import moment from 'moment';
import {QrcodeOutlined} from '@ant-design/icons';
import {QrContainer} from '../../../assign-rm-inventory/src/lib/qr-scanner'

const { Option } = Select;
/* eslint-disable-next-line */
export interface AssignSoakingMaterialProps {}

export function AssignSoakingMaterial(
  props: AssignSoakingMaterialProps
) {
  const [assignSoakingMaterialForm] = Form.useForm();
  const [workStations, setWorkStations] = useState<WorkStationsDropDown[]>([]);
  const [lotNumbers, setLotNumbers] = useState<LotCodeDropDown[]>([]);
  const [workStationType, setWorkStationType] = useState<WorkStationTypeEnum>(WorkStationTypeEnum.INTERNAL);
  const [lotNoInfo, setLotNoInfo] = useState<LotNoInfo>(undefined);
  const [boxWeight, setBoxWeight] = useState<number>(0);
  const [workStationData, setWorkStationData] = useState<WorkstationDTO>(undefined);
  const [disable, setDisable] = useState<boolean>(false)
  const [showQrSacn, setShowQrScan] = useState<boolean>(false);

  const productionInvService = new ProdInvService();
  const prodInvService = new ProductionInventoryService();
  const workstationService = new WorkstationService();
  const soakingAssignmentService = new SoakingAssignmentService();
  useEffect(() => {
    getWorkStations();
    getLotNumbers();
  }, [])

  const getWorkStations = () => {
    const catReq = new WorkStationCategoryReq();
    catReq.workstationCategory = 5;
    catReq.unitId = Number(localStorage.getItem('unit_id'));
    workstationService.getWorkStationsForCategory(catReq).then((res) => {
      if (res.status) {
        setWorkStations(res.data);
      } else {
        setWorkStations([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setWorkStations([]);
    });
  }

  const getLotNumbers = () => {
    const plant = Number(localStorage.getItem('unit_id'))
    const lotNoReq = new LotNumberRequest(plant, OperationTypeEnum.SOAKING);
    
    prodInvService.getLotNumbers(lotNoReq).then((res) => {
      if (res.status) {
        setLotNumbers(res.data);
      } else {
        setLotNumbers([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setLotNumbers([]);
    });

  }

  
  const checkWorkStationCapacity = () => {
    const lotQty = assignSoakingMaterialForm.getFieldValue("physicalQuantity");
    const plant = Number(localStorage.getItem('unit_id'))
    const workStationId = assignSoakingMaterialForm.getFieldValue("workstation")
    if(workStationId>0){
      workstationService.getWorkstationCapacity({workstationId:workStationId,unitId:plant}).then((res) => {
        if(res.status){
          console.log(lotQty);
          console.log(res.data);

          if(Number(lotQty) > Number(res.data.workstationUnitCapacity)){
            AlertMessages.getWarningMessage("WorkStation capacity exceeded. ");
            assignSoakingMaterialForm.setFieldsValue({workstation:null});
          }
          setWorkStationData(res.data);
        }else{
          setWorkStationData(undefined);
        }
      }).catch((err) => {
        setWorkStationData(undefined);
        AlertMessages.getErrorMessage(err.message);
      });
    }
    else{
      AlertMessages.getWarningMessage("Please select workStation. ");
    }
  }
  const getLotNumberInfo = (lotNumber) => {
    const plant = Number(localStorage.getItem('unit_id'))
    const lotNoReq = new LotInformationRequest(lotNumber, plant, OperationTypeEnum.SOAKING)
    prodInvService.getLotNumberInfo(lotNoReq).then((res) => {
      if (res.status) {
        setLotNoInfo(res.data)
        let boxWeight = (res.data.availableQuantity)/(res.data.boxes);
        setBoxWeight(boxWeight);
        assignSoakingMaterialForm.setFieldsValue({
          productionInventoryId:res.data.productionInventoryId,
          saleOrderId:res.data.saleOrderId,
          saleOrder:res.data.saleOrderNo,
          count:res.data.count,
          boxes:res.data.boxes,
          availableQuantity:res.data.availableQuantity,
          physicalQuantity:res.data.availableQuantity,
          inputGrade:res.data.inputGrade,
          saleOrderItemId:res.data.saleOrderItemId,
          soakingStyle:res.data.soakingStyle,
          soakingTime:res.data.soakingTime,
        })
        checkWorkStationCapacity();
      } else {
        setLotNoInfo(undefined);
      }
    }).catch((err) => {
      setLotNoInfo(undefined);
      AlertMessages.getErrorMessage(err.message);
    });
  }


  const onFinish = () => {
    setDisable(true)
    const formInfo = assignSoakingMaterialForm.getFieldsValue();
    console.log(formInfo);
    formInfo.createdUser = localStorage.getItem('createdUser');
    formInfo.plantId = localStorage.getItem('unit_id');
    console.log("my data is:",formInfo);
    soakingAssignmentService.createSoakingAssignment(formInfo).then((res) => {
      setDisable(false)
      if (res.status) {
        AlertMessages.getSuccessMessage(res.internalMessage);
        onReset();
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    }).catch((err) => {
      setDisable(false)
      AlertMessages.getErrorMessage(err.message);
    });
  }
  const onReset=()=>{
    assignSoakingMaterialForm.resetFields();
    
  }
  const calculateIssuingQty = () =>{
    const noOfBoxes = assignSoakingMaterialForm.getFieldValue('boxes');
    const availableQuantity = assignSoakingMaterialForm.getFieldValue('availableQuantity');
    // const boxWeight = availableQuantity/noOfBoxes;
    const physicalQuantity = boxWeight*noOfBoxes;
    if(physicalQuantity<=availableQuantity){
      assignSoakingMaterialForm.setFieldsValue({physicalQuantity:physicalQuantity});
    }else{
      assignSoakingMaterialForm.setFieldsValue({physicalQuantity:0, boxes:0});
    }
  }

  const handleQrScan = (lotcode) => {
    setShowQrScan(false)
    assignSoakingMaterialForm.setFieldsValue({
      subLotNumber:lotcode

    })
  }

  return (
    <Card title={<span style={{ color: 'white' }}>Soaking Assignment</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/soaking-assignment-grid' ><Button className='panel_button' >View </Button></Link>}>
      <Form layout={'vertical'} form={assignSoakingMaterialForm} name="control-hooks">

        <Row gutter={24}>
          <Form.Item name="productionInventoryId" >
            <Input hidden />
          </Form.Item>
          <Form.Item name="boxes" >
            <Input hidden />
          </Form.Item>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{ display: (workStationType == WorkStationTypeEnum.INTERNAL) ? 'block' : 'none' }}>
            <Form.Item name="workstation" label="Workstation" rules={[{ required: true, message: 'Missing Workstation' }]} >
            <Select
              placeholder="Select Workstation"
              onChange={checkWorkStationCapacity}
              allowClear
            >
              {workStations.map(dropData => {
                      return <Option key={dropData.workstationId} value={dropData.workstationId}>{dropData.workstation}</Option>
                    })}
            </Select>
          </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, }} lg={{ span: 5, }} xl={{ span: 5, }}>
          <Form.Item name="assignedTime" label="Input Time" rules={[{ required: true }]} initialValue={moment()}>
                  <DatePicker showTime={{format: "HH:mm"}} style={{ width: '100%' }} format="YYYY-MM-DD HH:mm:ss"
                  showToday={true} defaultValue={moment('YYYY-MM-DD HH:mm:ss')}/>
              </Form.Item>
          {/* <Form.Item  name="assignedTime" label="Input Time" rules={[{ required: true,message: 'Missing Input Time' }]}>
          <DatePicker showTime={{format: "HH:mm"}} style={{ width: '100%' }} format="YYYY-MM-DD HH:mm:ss"
                  showToday={true} defaultValue={moment('YYYY-MM-DD HH:mm:ss')}/>
           
            </Form.Item> */}
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
          <label style={{textAlign:'start',marginRight:'45%'}}>Sub Lot code <span style={{color: '#1890ff'}}> scan <QrcodeOutlined  onClick={(e) =>  setShowQrScan(true) } style={{ color: '#1890ff', fontSize: '20px' }} /></span> </label>

            <Form.Item name="subLotNumber" label={false} rules={[{ required: true, message: 'Missing Sub Lot Code' }]}>
              <Select
                placeholder="Select Sub Lot Code"
                allowClear
                onChange={getLotNumberInfo}
                dropdownMatchSelectWidth={false}
              >
                {lotNumbers.map(dropData => {
                  return <Option key={dropData.subLotNumber} value={dropData.subLotNumber}>{dropData.subLotNumber}</Option>
                })}
              </Select>
            </Form.Item>

          </Col>
          <Form.Item name="saleOrderId">
              <Input hidden/>
            </Form.Item>
          <Form.Item name="saleOrderItemId">
              <Input hidden/>
            </Form.Item>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <Form.Item name="saleOrder" label="SO Number" rules={[{ required: true, message: 'Missing Sale Order No' }]}>
              <Input disabled/>
            </Form.Item>

            </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
         <Form.Item name="inputGrade" label="Input Grade" rules={[{ required: true, message: 'Missing Input Grade' }]}>
            <InputNumber style={{ width: '100%' }} min={0} onChange={calculateIssuingQty} disabled/>
          </Form.Item>

          </Col>


          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <Form.Item name="physicalQuantity" label="Issuing Quantity" rules={[{ required: true, message: 'Missing Issuing Quantity' }]}>
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>

          </Col>
          <Col span={4}>
                <Form.Item name="soakingStyle" label="Soaking Style" rules={[{ required: true, message: 'Missing Soaking Style' }]}>
                  <Input style={{ width: '100%' }} disabled/>
                  
                  {/* <Select
                    placeholder="Soaking Style"
                    allowClear
                  >
                    <Option label={'soakingStyle'} value="STPP+SALT">STPP+SALT</Option>
                    <Option label={'soakingStyle'} value="Only SALT">Only SALT</Option>
                    <Option label={'soakingStyle'} value="NP + SALT">NP + SALT</Option>
                    <Option label={'soakingStyle'} value="CP + SALT"> CP + SALT</Option>
                  </Select> */}
                </Form.Item>
              </Col>
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <Form.Item name="soakingTime" label="Soaking Time (Min)" rules={[{ required: true, message: 'Missing Soaking Time' }]}>
              <InputNumber style={{ width: '100%' }} disabled/>
            </Form.Item>

          </Col>
         </Row>
         <Row>
          {/* <Col>
            <Form.Item style={{ paddingTop: '25px' }}>
              <Button type='primary' block onClick={onFinish}>
                Submit
              </Button>
            </Form.Item>
          </Col> */}
          <Col span={24} style={{ textAlign: 'right' }}>
          
            <Button type="primary"disabled={disable} onClick={onFinish} htmlType="submit" >
              Submit
            </Button>
            <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
                Reset
            </Button>
        </Col>

        </Row>
      </Form>
      <Modal
        className='qr-scan'
        key={'modal' + Date.now()}
        width={'90%'}
        style={{ top: 30, alignContent: 'right' }}
        visible={showQrSacn}
        title={<React.Fragment>
        </React.Fragment>}
        onCancel={() => setShowQrScan(false)}
        footer={[

        ]}
      >
       <QrContainer handleScan={handleQrScan} /> 

       
        
      </Modal>
    </Card>
  );
}

export default AssignSoakingMaterial;